import { c as _c } from "react/compiler-runtime";
import type { BackupVault } from '@repo/api-gw-sdk';
import { useState } from 'react';
import { KMSKeyEditorPanel } from './kmsKeyEditorPanel';
import { ChangeableTextField } from '../text/changeableTextField';
export const AwsKmsTextField = t0 => {
  const $ = _c(11);
  const {
    backupVault,
    setBackupVault
  } = t0;
  const [openKmsKeyEditor, setOpenKmsKeyEditor] = useState(false);
  const encryptionKey = backupVault.vaultAttributes.aws?.encryptionKey;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => setOpenKmsKeyEditor(true);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] !== encryptionKey) {
    t2 = <ChangeableTextField value={encryptionKey} onClick={t1} placeholder="No key set" noValueButtonText="Set Key" />;
    $[1] = encryptionKey;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = () => setOpenKmsKeyEditor(false);
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== backupVault || $[5] !== openKmsKeyEditor || $[6] !== setBackupVault) {
    t4 = <KMSKeyEditorPanel open={openKmsKeyEditor} onClose={t3} data={backupVault} setData={setBackupVault} />;
    $[4] = backupVault;
    $[5] = openKmsKeyEditor;
    $[6] = setBackupVault;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== t2 || $[9] !== t4) {
    t5 = <>{t2}{t4}</>;
    $[8] = t2;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  return t5;
};